import { NewsPageModules } from 'static/constants'

export const getGaioConfigLimit = (gaioConfig, key) => gaioConfig?.get(key) || 0

export const DEFAULT_GAIO_PROMPT_FREQUENCY = 'daily'
export const GAIO_PROMPT_FREQUENCIES = ['daily', 'weekly', 'biweekly', 'monthly']
export const GAIO_PROMPT_FREQUENCY_EXECUTIONS_PER_MONTH = {
  daily: 30,
  weekly: 4,
  biweekly: 2,
  monthly: 1
}

export const isGaioLimitReached = (count, limit) => limit > 0 && count >= limit

export const getGaioLimitSeverity = (count, limit, fallbackSeverity = null, threshold = 0.8) => {
  if (isGaioLimitReached(count, limit)) {
    return 'error'
  }

  if (limit > 0 && count >= limit * threshold) {
    return 'warning'
  }

  return fallbackSeverity
}

export const withGaioProjectId = (searchBody, gaioProjectId) => {
  if (searchBody.module_name !== NewsPageModules.GAIO || gaioProjectId == null) {
    return searchBody
  }

  return {
    ...searchBody,
    module_name: NewsPageModules.GAIO,
    news: {
      ...searchBody.news,
      gaio_project_id: [gaioProjectId]
    }
  }
}

export const isProfessionalPlan = planId => (
  [3, 7, 11, 15, 19, 23, 27].includes(planId)
)

export const ownBrandCsvLabel = (ownBrands, { mentioned, notMentioned }) => (
  (ownBrands || [])
    .filter(code => code && code.name)
    .map(code => `${code.name} (${code.mentioned ? mentioned : notMentioned})`)
    .join(', ')
)
